// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"440":"3bffbfe2","453":"e8507c5b","518":"c88a53b6","586":"afaaca15","710":"7dee9430","837":"3a08f928"}[chunkId] + ".chunk.js";
};